import React from "react";
import { Calendar, Modal, Icon, Button, Input, Popconfirm } from "antd";
import moment from "moment";
import axios from "axios";

import "./Calendar.scss";

class Overview extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      schedule: {},
      classes: {},
      access: false,
      password: '',
      modal: false,
      loading: false,
      date: moment(),
      bookings: {},
      new: {}
    };
  }

  componentDidMount() {    
    axios({
      method: "GET",
      // url: `https://rga.cromasome.com/api/courses/calendar`,
      url: `http://144.76.199.153:4004/api/bookings/v1/calendar`,
      headers: {
        "Content-Type": "application/json",
      },
      json: true,
    })
      .then((response) => {
        if (response.status === 200) {          
          let classes = {}
          let schedule = {}
          for(const day of response.data) {
            classes[day.day] = {}
            schedule[day.day] = {}
            for(const _class of day.classes) {
              classes[day.day][_class.time] = _class.name
              schedule[day.day][_class.time] = []
            }
          }          
          this.setState({ classes, schedule });
        }        
      })
      .catch((err) => {
        console.log("Request Network Error");
      });
  }

  handleCancel = _e => {
    this.setState({ modal: false });
  }

  onSelect = _e => {    
    this.setState({
      loading: true,
      date: _e, 
      modal: true
    });    
    
    axios({
      method: "GET",
      // url: `https://rga.cromasome.com/api/lectures/date/${_e.format('YYYY-MM-DD')}`,
      url: `http://144.76.199.153:4004/api/bookings/v1/lecture/date/${_e.format('YYYY-MM-DD')}`,
      headers: {
        "Content-Type": "application/json"
      },      
      json: true
    })
    .then(response => {            
      if (response.status === 200) {
        if(response.data.success) {          
          this.setState({ loading: false, bookings: response.data.data, new: {} })
        }
      } else {
        this.setState({ loading: false })
      }
    })
    .catch(err => {
      this.setState({ loading: false })
    });        
  }

  reloadLectures = () => {
    axios({
      method: "GET",
      // url: `https://rga.cromasome.com/api/lectures/date/${this.state.date.format('YYYY-MM-DD')}`,
      url: `http://144.76.199.153:4004/api/bookings/v1/lecture/date/${this.state.date.format('YYYY-MM-DD')}`,
      headers: {
        "Content-Type": "application/json"
      },      
      json: true
    })
    .then(response => {      
      if (response.status === 200) {
        if(response.data.success) {          
          this.setState({ loading: false, bookings: response.data.data, new: {}})
        }
      } else {
        this.setState({ loading: false })
      }
    })
    .catch(err => {
      this.setState({ loading: false })
    });
  }

  removeLecture = _e => {
    console.log("_e_", _e);
    this.setState({
      loading: true
    });  

    axios({
      method: "DELETE",
      // url: `https://rga.cromasome.com/api/lectures/index/${_e}`,
      url: `http://144.76.199.153:4004/api/bookings/v1/lecture/${_e}`,
      headers: {
        "Content-Type": "application/json"
      },      
      json: true
    })
    .then(response => {      

      if (response.status === 200) {        
        if(response.data.success) {
          
          setTimeout( () => {                            

            this.reloadLectures()

          }, 100);          
        }
      } else {
        this.setState({ loading: false })
      }
    })
    .catch(err => {
      this.setState({ loading: false })
    });    
  }

  handleNew = (_time, _value) => {

    const _new = this.state.new;
    _new[_time] = _value;  

    this.setState({
      new: _new
    })
  }

  addNew = _time => {    

    const _value = this.state.new[_time];

    const _dateDay = this.state.date.format('dddd');

    if(_value !== '') {

      this.setState({
        loading: true
      });  

      const _data = {
        time: _time,
        date: this.state.date.format("YYYY-MM-DD"),
        class: this.state.classes[_dateDay][_time],
        name: _value
      }
      axios({
        method: "POST",
        // url: `https://rga.cromasome.com/api/lectures/index`,
        url: `http://144.76.199.153:4004/api/bookings/v1/lecture`,
        headers: {
          "Content-Type": "application/json"
        },
        data: _data,
        json: true
      })
      .then(response => {
        console.log("response", response);
        if (response.status === 200) {
          if(response.data.success) {
            setTimeout( () => {                            

              this.reloadLectures()
  
            }, 100);  
          }
        } else {
          console.log("Error")
        }
      })
      .catch(err => {
        console.log("Error")
      });
    }
  }

  passwordChange = _e => {
    this.setState({ password: _e.target.value });
  }

  passwordClick = _e => {
    if(this.state.password === 'nocreonte') {
      this.setState({access: true});
    }    
  }

  render() {
    const _bookings = this.state.bookings;
    const _dateDay = this.state.date.format('dddd');        
    // Extend the Empty classes
    const __bookings = {...this.state.schedule[_dateDay], ..._bookings}    

    if(this.state.access) {
      return (
        <div className="calendar">
          <Calendar 
            onSelect={this.onSelect}
          />
          <Modal
            title={this.state.date.format('dddd. MMMM Do YYYY')}
            visible={this.state.modal}
            onOk={this.handleCancel}
            onCancel={this.handleCancel}
            width='100%'
          >
            <h1>{this.state.date.format('dddd. MMMM Do YYYY')}</h1>
            {this.state.loading ? 
            <>
              <Icon type="loading" style={{fontSize: 30}}></Icon>
            </>
            :
            <>
              {Object.keys(__bookings).map((_time, _i) => (
                <div className="class" key={_i}>
                  <div className="classTitle">
                    <h2>{_time} - {this.state.classes[_dateDay][_time]}  ({__bookings[_time].length} Students)</h2>
                    <div className="form">
                      <Input 
                        onChange={_e => this.handleNew(_time, _e.target.value)}
                        value={this.state.new[_time]}
                      >                          
                      </Input>
                      <Button 
                        icon="plus" 
                        type="primary" 
                        onClick={_e => this.addNew(_time)}
                        disabled={this.state.new[_time] ? false : true}
                      >
                        Add Student
                      </Button>
                    </div>                                
                  </div>                    
                  <div className="persons">
                    {__bookings[_time].map((_person, _j) => (                   
                      <div key={_j} className="personBox">
                        <div className="person">                        
                          <span className="personName"><Icon type="user"/></span>
                          <Popconfirm
                            title={`Are you sure to remove ${_person.name} ?`}
                            onConfirm={_e => this.removeLecture(_person.id)}
                            onCancel={()=> console.log("onCancel")}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button size="small" type="danger" icon="close"></Button>
                          </Popconfirm>                          
                        </div>
                        <div>{_person.name}</div>
                      </div>
                    ))}
                  </div>                
                </div>
              ))}
            </>
            }
          </Modal>
        </div>
      );
    } else {
      return (
        <div className="password">
          <Input type="password" onChange={this.passwordChange}></Input>
          <Button type="primary" onClick={this.passwordClick}>Go</Button>
        </div>
      )
    }    
  }  
}

export default Overview;
